module.exports = __webpack_public_path__ + "static/media/grupodeestudos.f20ff81e.jpg";